<div class="pdf-page app-cp-10-33-10-12" id="cp331012">
  <p class="font-small text-end">
    <b
      >COMMERCIAL PROPERTY<br />
      CP 10 33 10 12</b
    >
  </p>
  <p class="font-medium" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY</b>
  </p>
  <p class="font-large" style="text-align: center"><b>THEFT EXCLUSION</b></p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>
  <br />
  <p class="font-small ps-10">CAUSES OF LOSS – SPECIAL FORM</p>
  <p class="font-small" style="text-align: center"><b>SCHEDULE</b></p>
  <table
    class="font-sm"
    style="width: 100%; border: 1px solid black; border-collapse: collapse"
  >
    <thead>
      <tr>
        <th
          style="
            text-align: center;
            width: 50%;
            border: 1px solid black;
            padding: 5px;
          "
        >
          Premises Number
        </th>
        <th
          style="
            text-align: center;
            width: 50%;
            border: 1px solid black;
            padding: 5px;
          "
        >
          Building Number
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 5px">&nbsp;</td>
        <td style="border: 1px solid black; padding: 5px"></td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">&nbsp;</td>
        <td style="border: 1px solid black; padding: 5px"></td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">&nbsp;</td>
        <td style="border: 1px solid black; padding: 5px"></td>
      </tr>
      <tr>
        <td colspan="2" style="border: 1px solid black; padding: 5px">
          Information required to complete this Schedule, if not shown above,
          will be shown in the Declarations
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <table class="font-sm">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top;">
          With respect to the location(s) indicated in the Schedule, the
          following is added to the <b>Exclusions</b> section: <br />
          We will not pay for loss or damage caused by or resulting from theft.
          <br />
          But we will pay for:
          <ol>
            <li style="font-weight: bold;">
              <span style="font-weight: normal;">
              Loss or damage that occurs due to looting at the time and place of
              a riot or civil commotion; or
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top;">
          <ol start="2">
            <li style="font-weight: bold; ">
              <span style="font-weight: normal;">
              Building damage caused by the breaking in or exiting of burglars.
            </span>
            </li>
          </ol>
          And if theft results in a Covered Cause of Loss, we will pay for the
          loss or damage caused by that Covered Cause of Loss.
        </td>
      </tr>
    </tbody>
  </table>
</div>
